import { createApp } from 'vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useThemeStore } from '@/stores/theme';
import { registerServiceWorker } from '@/pwa/registerServiceWorker';
import App from './App.vue';
import router from './router';
import { i18n } from './locales';
import './styles/main.css';

const app = createApp(App);

// Pinia store
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
useThemeStore();
app.use(router);
app.use(i18n);

app.mount('#app');

// Register the PWA service worker (production builds only; no-op in dev/test).
registerServiceWorker();
